// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3qXWb","error":"Textarea_error__2Iz2G","readonly":"Textarea_readonly__30TwW","disabled":"Textarea_disabled__1BaZA"};